module.exports = __webpack_public_path__ + "img/User.7b7fa438.png";